
import { IconProps } from '../../types/IconProps';

export const Check = ({ variant, className }: IconProps) => {
    let color;
    switch (variant) {
        case 'light':
            color = '#fff';
            break;
        case 'dark':
            color = '#0B223E';
            break;
        default:
            color = '#fff';
    }
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            className={`${className || ''}`}>
            <g id="icon=check">
                <path id="Icon" d="M20 6L9 17L4 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>

        </svg>
    );
};

